import * as api from "..";
import { AI } from "../config/endpoints";

interface CampaignService {
  getAiPartnerDescription: (body: {
    prompt: string;
    maxLength: number;
  }) => Promise<any>;
  getAiCampaignDescription: (body: {
    prompt: string;
    maxLength: number;
  }) => Promise<any>;
}

const aiService: CampaignService = {
  getAiPartnerDescription: async (body) => {
    const resp = await api.post(AI.aiPartnerDescription, body);
    return resp;
  },
  getAiCampaignDescription: async (body) => {
    const resp = await api.post(AI.aiCampaignDescription, body);
    return resp;
  },
};

export default aiService;
